import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FaStripe } from "react-icons/fa";
import dayjs from "dayjs";
import "dayjs/locale/es";

function StripeSummary({ financialInfo }) {
  return (
    <Col className="financial-info">
      <h4 className="text-center mb-0">
        Balance <FaStripe /> del mes{" "}
      </h4>
      <p className="text-center">
        {dayjs(financialInfo.startOfMonth).locale("es").format("DD/MMM/YYYY")} -{" "}
        {dayjs(financialInfo.today).locale("es").format("DD/MMM/YYYY")}
      </p>
      {financialInfo ? (
        <>
          <Row>
            <Col lg={6} sm={12} xs={12} className="financial-concept-title">
              <p>Balance Inicial:</p>
            </Col>
            <Col lg={6} sm={12} xs={12} className="financial-concept-value">
              <p>
                {financialInfo.startingBalance.toLocaleString("es-MX", {
                  style: "currency",
                  currency: "MXN",
                })}
              </p>
            </Col>
          </Row>
          <Row>
            <Col lg={6} sm={12} xs={12} className="financial-concept-title">
              <p>Actividad:</p>
            </Col>
            <Col lg={6} sm={12} xs={12} className="financial-concept-value">
              <p>
                {financialInfo.successfulTransactionsVolume.toLocaleString(
                  "es-MX",
                  {
                    style: "currency",
                    currency: "MXN",
                  },
                )}
              </p>
            </Col>
          </Row>
          <Row>
            <Col lg={6} sm={12} xs={12} className="financial-concept-title">
              <p>Comisiones:</p>
            </Col>
            <Col lg={6} sm={12} xs={12} className="financial-concept-value">
              <p>
                -
                {financialInfo.totalFees.toLocaleString("es-MX", {
                  style: "currency",
                  currency: "MXN",
                })}
              </p>
            </Col>
          </Row>
          <Row>
            <Col lg={6} sm={12} xs={12} className="financial-concept-title">
              <p>Transferencias:</p>
            </Col>
            <Col lg={6} sm={12} xs={12} className="financial-concept-value">
              <p>
                -
                {financialInfo.totalPayouts.toLocaleString("es-MX", {
                  style: "currency",
                  currency: "MXN",
                })}
              </p>
            </Col>
          </Row>
          <Row>
            <Col lg={6} sm={12} xs={12} className="financial-concept-title">
              <p>Reembolsos:</p>
            </Col>
            <Col lg={6} sm={12} xs={12} className="financial-concept-value">
              <p>
                -
                {financialInfo.totalRefunds.toLocaleString("es-MX", {
                  style: "currency",
                  currency: "MXN",
                })}
              </p>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col lg={6} sm={12} xs={12} className="financial-concept-title">
              <p>Balance final:</p>
            </Col>
            <Col lg={6} sm={12} xs={12} className="financial-concept-value">
              <p>
                {financialInfo.currentBalance.toLocaleString("es-MX", {
                  style: "currency",
                  currency: "MXN",
                })}
              </p>
            </Col>
          </Row>
        </>
      ) : (
        <p>Loading...</p>
      )}
    </Col>
  );
}

export default StripeSummary;
